"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var cityBuilder = function cityBuilder(_a) {
  var city = _a.city;

  if (!city) {
    return '';
  }

  return "city:\"" + city + "\"";
};

var _default = cityBuilder;
exports["default"] = _default;